import { g as HttpStatus, p as ApiError, s as HttpHeader } from "./createFetchClient-CkHdS_IG.js";
//#region src/keboola/bearer/credentials/middleware.ts
const isUnauthorized = (error) => error instanceof ApiError && error.response.status === HttpStatus.UNAUTHORIZED;
/**
* Bearer auth: stamps the access token; on a 401, force-refreshes and replays once.
*
* - A replay that still 401s passes on, not as expiry: an unreachable project gets the same 401.
* - Anonymous (`null` token): passes through untouched, so `login` / `refresh` work.
* - A `forceRefresh` answering `null` stops the replay.
*/
const createBearerAuthMiddleware = (credential) => {
	return (next) => async (request) => {
		const token = await credential.getAccessToken({ forceRefresh: false });
		if (token === null) return next(request);
		const retryRequest = request.request.clone();
		request.request.headers.set(HttpHeader.AUTHORIZATION, `Bearer ${token}`);
		try {
			return await next(request);
		} catch (error) {
			if (!isUnauthorized(error)) throw error;
			const refreshed = await credential.getAccessToken({ forceRefresh: true });
			if (refreshed === null) throw error;
			retryRequest.headers.set(HttpHeader.AUTHORIZATION, `Bearer ${refreshed}`);
			return await next({
				...request,
				request: retryRequest
			});
		}
	};
};
//#endregion
export { isUnauthorized as n, createBearerAuthMiddleware as t };

//# sourceMappingURL=middleware-CWaLMlG1.js.map